import { generateActions } from "../utils";

export const GET_CATEGORIES = generateActions("GET_CATEGORIES");
